import api from '@/api';

const basePath = '/offers/';

/**
 * Запрашивает текущую оферту и статус принятия для роли пользователя.
 * @returns {Promise<AxiosResponse>} ответ с полями id, role, version, title, file_url, accepted и др.
 */
function getCurrent() {
  return api.get(`${basePath}current/`);
}

/**
 * Отправляет подтверждение принятия оферты пользователем.
 * @param {Object} body — тело запроса.
 * @param {number} body.offer_id — id из ответа GET current.
 * @param {number} body.max_scroll_ratio — доля прокрутки (0–1).
 * @param {string} body.consent_result — "accepted" или "declined".
 * @param {string} body.consent_text — точный текст с галочки/кнопки согласия.
 * @param {string} [body.transition_text] — текст согласия на переход со старого договора, если показывался.
 * @returns {Promise<AxiosResponse>} 204 No Content при успехе.
 */
function accept(body) {
  return api.post(`${basePath}current/accept/`, body);
}

export default {
  getCurrent,
  accept,
};
